/**
 * Analytics event tracking - Privacy-focused, no sensitive data
 * Tracks: page loads, user actions, errors, and session duration
 */
import ReactGA from 'react-ga4';

/**
 * Track user uploaded local files
 */
export const trackLocalFilesUploaded = () => {
  ReactGA.event({
    category: 'Usage',
    action: 'Local Files Uploaded',
    value: 1
  });
};

/**
 * Track user loaded GitHub repository
 */
export const trackGitHubRepoLoaded = () => {
  ReactGA.event({
    category: 'Usage',
    action: 'GitHub Repo Loaded',
    value: 1
  });
};

/**
 * Track site error occurrence
 * @param {string} errorType - Type of error (e.g., 'GitHub API', 'File Load', 'Parse Error')
 */
export const trackError = (errorType) => {
  ReactGA.event({
    category: 'Error',
    action: errorType,
    value: 1
  });
};

/**
 * Track session duration
 * @param {number} durationSeconds - Session duration in seconds
 */
export const trackSessionDuration = (durationSeconds) => {
  ReactGA.event({
    category: 'Session',
    action: 'Duration',
    value: Math.round(durationSeconds)
  });
};
